/** What a monitoring program selects; each registered PSV source belongs to one family. */
export enum PsvSourceFamily {
  StateLicense = "state-license",
  StateMedicaidExclusion = "state-medicaid-exclusion",
  Dea = "dea",
  Npi = "npi",
  MedicareOptOut = "medicare-opt-out",
  Sam = "sam",
  Oig = "oig",
  Ofac = "ofac",
}

export enum PsvMonitoringStateScope {
  All = "all",
  Selected = "selected",
}

/** Families whose checks are issued per state and so carry a state scope. */
export const PSV_STATE_SCOPED_SOURCE_FAMILIES: readonly PsvSourceFamily[] = [
  PsvSourceFamily.StateLicense,
  PsvSourceFamily.StateMedicaidExclusion,
];

/** How a family is covered once every applicable program's selection is merged. */
export enum PsvResolvedScopeKind {
  National = "national",
  AllStates = "all-states",
  States = "states",
}

/** How a program reached a provider: directly, or through a pool member row. */
export enum PsvMonitoringTargetKind {
  Provider = "provider",
  Pool = "pool",
}

/** Why a provider's BU view is not monitored, checked in this order. */
export enum PsvMonitorIneligibilityReason {
  FeatureDisabled = "feature-disabled",
  AffiliationEnded = "affiliation-ended",
  /** The BU has recorded no credentials for the provider, so its view does
   * not exist yet and there is nothing to re-check. */
  NoCredentialFile = "no-credential-file",
  ViewFrozen = "view-frozen",
  NotTargeted = "not-targeted",
}

export enum PsvMonitoringProgramStatus {
  Active = "active",
  Paused = "paused",
  Archived = "archived",
}

/** The name "turn on monitoring" gives the standard rule it creates. The rule
 * is identified by its `isStandard` flag, never by this name. */
export const STANDARD_RULE_NAME = "Standard monitoring";
